export default "__VITE_ASSET__6fa46464__"